'use client';
import { useSearchParams } from 'next/navigation';
import { ucfirst } from '@/packages/string';
import IconChannelList from '@/assets/icons/icon-channel-list.svg';
import IconDropDown from '@/assets/icons/icon-dropdown.svg';
import { useYmm20 } from '@/hooks/useYmm';
import { useChannelGuideData } from '@/hooks/useChannelGuideData';
import { requestYmmModal } from '@/packages/sxm/ymm/ymmModalEvent';
import { ChannelGuideData } from '@/services/contentful/contentTypes/ChannelGuide';
import { PLATFORM } from '@/constants';
import { SortedChannels } from './interfaces';

import styles from './channelGuide.module.scss';

const { ymmTriggerWrapper, iconStyle, packageBySearchParamWrapper } = styles;

interface YmmTriggerProps {
    packageId: string;
    channels: SortedChannels | null;
    allPackages: ChannelGuideData['fields']['allPackages'];
    getPackageById: ReturnType<typeof useChannelGuideData>['getPackageById'];
}

export default function YmmTrigger({ packageId, channels, allPackages, getPackageById }: YmmTriggerProps) {
    const searchParams = useSearchParams();
    const { ymmTextBar } = useYmm20();

    if (!packageId && !channels) {
        return null;
    }

    const id = packageId || allPackages[0].fields.sms_package_id;
    const sxmPackage = id ? getPackageById(id) : null;
    const platform = ucfirst(
        sxmPackage?.fields.platform.replace(/ip/gi, PLATFORM.SIRIUSXM) || PLATFORM.SIRIUSXM,
    ).replace(/xm/gi, 'XM');

    if (searchParams.get('package')) {
        return (
            <div className={packageBySearchParamWrapper}>
                Showing channels for {platform}&nbsp;<b>{` ${sxmPackage?.fields.package_display_name}`}</b>
            </div>
        );
    }

    return (
        <div className={ymmTriggerWrapper}>
            <button onClick={requestYmmModal} className={styles.ymmButton}>
                <span className={styles.ymmPreTextBar}>
                    <IconChannelList className={styles.channelIcon} />
                    Ch. numbers for:
                </span>
                <span className={styles.ymmTextBar}>
                    {ymmTextBar} <IconDropDown className={iconStyle} />
                </span>
            </button>
        </div>
    );
}
